import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withLocalize, Translate } from 'react-localize-redux';
import { REGISTRY, SEARCH_TYPE } from '../../../store/ceeSearchStore';
import { hasPermission } from '../../../store/apiWrapper';


class FormButtonsRow extends React.Component {
    render() {
        return (
            <>
                <div className='columns m-0 is-centered has-text-centered'>
                    <div className='column is-narrow'>
                        <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                            type='submit'
                            style={{ fontWeight: 600 }}
                            disabled={this.props[this.props.registry].isRequesting || this.props.disabled}
                            onClick={() => this.props.clickCallBack('default')}
                        >
                            {this.props[this.props.registry].isRequesting ? <FontAwesomeIcon icon="cog" spin /> : <Translate id={(this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve )? 'Search.CRE.Button.CRE' : 'Search.Common.Search'} />}
                        </button>
                        {(this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve)
                            && ((this.props.selectedTab !== SEARCH_TYPE.bulk && this.props.selectedTab !== SEARCH_TYPE.trialFile && hasPermission(null, "SearchRPVE"))
                                || (this.props.selectedTab === SEARCH_TYPE.bulk && hasPermission(null, "RPVEBulk"))) &&
                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                type='submit'
                                style={{ fontWeight: 600 }}
                                disabled={this.props[this.props.registry].isRequesting || this.props.disabledRpve}
                                onClick={() => this.props.clickCallBack(REGISTRY.rpve)}
                            >
                                {this.props[this.props.registry].isRequesting ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Search.CRE.Button.RPVE' />}
                            </button>}
                    </div>
                </div>
            </>
        );
    }
}

export default withLocalize(connect(state => state.registrySearch)(FormButtonsRow));
